module.exports = __webpack_public_path__ + "img/26-df2b85.png";